import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ConfirmationDialogState } from './confirmation-dialog.state';
import { CloseDialog, OpenDialog, SetCloseResult } from './confirmation-dialog.actions';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationDialogFacade {
  private readonly store = inject(Store);

  @Select(ConfirmationDialogState.open) open$: Observable<boolean>;
  @Select(ConfirmationDialogState.title) title$: Observable<string>;
  @Select(ConfirmationDialogState.content) content$: Observable<string>;
  @Select(ConfirmationDialogState.closeResult) closeResult$: Observable<boolean | null>;

  openDialog(title: string, content: string) {
    this.store.dispatch(new OpenDialog(title, content));
  }

  closeDialog() {
    this.store.dispatch(new CloseDialog());
  }

  setCloseResult(closeResult: boolean | null) {
    this.store.dispatch(new SetCloseResult(closeResult));
  }
}
